var _foreignObject, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("switch", null, _foreignObject || (_foreignObject = /*#__PURE__*/React.createElement("foreignObject", {
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45 45h260v260H45z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 73h204v204H73z",
    style: {
      fill: "#006f93"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M229.75 101.75h-109.5c-9.389 0-17 7.611-17 17v109.5c0 9.389 7.611 17 17 17h109.5c9.389 0 17-7.611 17-17v-109.5c0-9.389-7.611-17-17-17M235.5 229a5 5 0 0 1-5 5h-111a5 5 0 0 1-5-5V118a5 5 0 0 1 5-5h111a5 5 0 0 1 5 5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61 147.278h228v52.306H61z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.444 166.775v37.309h257.889v-37.267l-7.679 7.665-12.386 12.364-12.474-12.374-3.189-3.164-3.169 3.183-5.16 5.184-7.13 7.162-12.478-12.367-3.179-3.151-3.168 3.162-12.378 12.356-7.205-7.186-5.185-5.171-3.198-3.189-3.178 3.209-12.207 12.329-12.469-12.358-3.172-3.144-3.168 3.148-12.432 12.354-12.245-12.333-3.172-3.195-3.193 3.173-12.437 12.36-12.3-12.344-3.159-3.171-3.188 3.143-12.551 12.374-12.202-12.334-3.168-3.202-3.199 3.171-12.479 12.368-12.304-12.349z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m284.278 193.194-15.653-15.528-15.458 15.528-15.667-15.528-15.556 15.528-15.569-15.528L191 193.194l-15.667-15.528-15.625 15.528-15.417-15.528-15.625 15.528-15.472-15.528-15.75 15.528-15.361-15.528-15.667 15.528-15.472-15.528v21.917h248.889v-21.917zm-202.195.973a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7m186.542 0a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7",
    style: {
      fill: "#fff"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M304.333 142.778H46.444v14.336l1.318 1.318 15.472 15.472 3.166 3.166 3.182-3.151 12.469-12.347 4.514 4.559 7.681 7.757 3.16 3.192 3.198-3.155 12.542-12.373 12.336 12.35 3.173 3.176 3.184-3.165 12.414-12.343 12.265 12.325 3.171 3.186 3.19-3.167 12.459-12.37 12.496 12.374 3.189 3.158 3.166-3.181 7.722-7.757 4.539-4.559 12.311 12.322 3.178 3.181 3.183-3.175 7.778-7.757 4.611-4.599L250 173.92l3.192 3.161 3.166-3.186 12.253-12.33 4.655 4.602 7.847 7.757 3.169 3.133 3.164-3.138 15.556-15.431 1.331-1.32z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.944 147.278v7.972l15.472 15.472 15.667-15.514 15.361 15.514 15.725-15.514 15.497 15.514 15.604-15.514 15.438 15.514 15.625-15.514L191 170.722l15.444-15.514 15.5 15.514 15.556-15.514 15.667 15.514 15.417-15.514 15.694 15.514 15.556-15.431v-8.014H50.944zm15.473 12.305a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7m217.861 0a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrost);
export default __webpack_public_path__ + "static/media/frost.04de7a9f42d73b61e469d8824ba93d63.svg";
export { ForwardRef as ReactComponent };